import { SeasonType, StageType } from '@/model';
import { t } from '@/i18n';
import { SeasonFormData } from '../schemas';

export type StageSummaryItem = {
  label: string;
  type: StageType;
};

/**
 * Deriva a lista de fases que serão criadas, a partir dos dados do formulário.
 * Usado na etapa de revisão (Step 3).
 */
export const buildStagesSummary = (values: SeasonFormData): StageSummaryItem[] => {
  if (values.season_type === SeasonType.LEAGUE) {
    return [
      {
        label: t('pages.application_season.components.season_step2.league.single_stage_label').toString(),
        type: StageType.LEAGUE,
      },
    ];
  }

  if (values.season_type === SeasonType.KNOCKOUT) {
    return values.knockout_stages.map(stage => ({
      label: stage.name,
      type: StageType.KNOCKOUT,
    }));
  }

  if (values.season_type === SeasonType.HYBRID) {
    return [
      ...values.group_stages.map(stage => ({
        label: stage.group_name,
        type: StageType.GROUP,
      })),
      ...values.knockout_stages.map(stage => ({
        label: stage.name,
        type: StageType.KNOCKOUT,
      })),
    ];
  }

  return [];
};
